import { loadTossPayments } from '@tosspayments/sdk';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import DaumPostCode from 'react-daum-postcode';
import { useForm } from 'react-hook-form';
import { clientKey, payment_root_url, root_url } from '../setting';
// import ReactToPrint from 'react-to-print';
import { useReactToPrint } from 'react-to-print';
import RunnersParticipantForm from './RunnersParticipantForm';
import { v4 as uuidv4 } from 'uuid';

//접수 확인 및 결제, 수정할 수 있는 옵션도 있으면 좋을 것 같다! Search.js와의 연동성도 있고...
const Payment = ({ setRes, res, history, title, isFromSearch = false, ticketInfo }) => {
  const componentToPrintRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentToPrintRef.current,
  });
  // console.log(isFromSearch);
  //res : {joiner, runner, runners} 데이터를 담고 있다.
  console.log('#####', res);
  console.log(ticketInfo);
  const [cookies, setCookie] = useCookies(['orderIdCookie']);
  const [isCard, setIsCard] = useState(false);
  const [needUpdateOnComp, setNeedUpdateOnComp] = useState(false);
  const [needUpdateOnRsvt, setNeedUpdateOnRsvt] = useState(false);
  const [popupShow, setPopupShow] = useState(false);
  const [address, setAddress] = useState({
    zonecode: '',
    roadAddress: '',
    buildingName: '',
  });
  const [choiceOption, setChoiceOption] = useState({});
  const [ticketOption, setTicketOption] = useState({});
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { joiner, runners } = res;
  const [runnerList, setRunnerList] = useState(runners);
  const [isPayPossible, setIsPayPossible] = useState(true);

  const [isEditPossible, setIsEditPossible] = useState(true); //cmpl인 joiner의 경우, 수정이 아예 불가하도록
  const runner = runners[0];
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    console.log('-------- 이 수술은 내가 집도 한다 --------');
    console.log(`runner가 누구???`, runner);
    console.log(`runners가 누구???`, runnerList);
    console.log(`joiner가 누구??`, joiner);
    let modifiedAmount = runnerList
      .map((runner) => {
        return ticketInfo[runner.ticketSeq - 1].ticketPrice;
      })
      .reduce((a, b) => a + b, 0);
    console.log(modifiedAmount);
    setRes({
      ...res,
      joiner: { ...joiner, amount: modifiedAmount },
      runners: runnerList,
    });
  }, [runnerList]);

  useEffect(() => {
    console.log('-------- 이 수술은 내가 집도 한다 --------');
    console.log(`runner가 누구???`, runner);
    console.log(`runners가 누구???`, runnerList);
    console.log(`joiner가 누구??`, joiner);
    console.log('나 바꼈음~!!!', res);
    console.log('runnerList', runnerList);
    console.log('joiner', joiner);
    console.log(runnerList.length);
  }, [res]);

  /*
  runners[0]
  backNo: null
  birthday: "31231232"
  cellphone: "01023123221"
  chipNo: null
  choiceOption: "M"
  createTime: "2021-08-01T12:22:01"
  gender: "M"
  joinSeq: 21
  runnerName: "최초치"
  runnerSeq: 56
  souvenir: "티셔츠"
  ticketName: "오프라인 10Km-A조"
  ticketSeq: 1
  ticketType: "offline"
  updateTime: "2021-08-01T12:22:01"  
  */

  console.log(runner);
  console.log(joiner);
  console.log(runners);
  let orderName = runners[0].ticketName;
  let orderListForUrl = '';
  if (runners.length !== 1) {
    let cnt = -1;
    for (let i = 0; i < runners.length; i++) {
      console.log(i);
      orderListForUrl += `${runners[i].ticketSeq} `;
      cnt += 1;
    }
    orderName = `${orderName} 외 ${cnt}건`;
  } else {
    for (let i = 0; i < runners.length; i++) {
      orderListForUrl += `${runners[i].ticketSeq} `;
    }
  }
  console.log(orderListForUrl);
  const onCompletePostCode = ({ zonecode, roadAddress, buildingName }) => {
    setPopupShow(false);
    setAddress({
      zonecode,
      roadAddress,
      buildingName,
    });
  };
  const 한국화폐표현 = (amount) => {
    if (typeof amount === "string") {
      amount = parseInt(amount, 10);
    }
    amount = amount.toLocaleString('ko-KR');
    return amount
  }
  const onUpdateRunner = async () => {
    //결제를 누르면, 참가자 정보를 업데이트 하고 결제가 진행되도록 한다.
    console.log('onUpdateRunner');
    console.group(runnerList);
    const runners = runnerList;
    axios({
      method: 'put',
      url: `${root_url}/api/application/update`,
      data: { joiner, runners },
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => {
        console.log(res);
        setNeedUpdateOnComp(false);
        setNeedUpdateOnRsvt(false);
      })
      .catch((e) => {
        if (e.response === undefined) {
          alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
        } else {
          alert(e.response.data.errorMessage);
        }
        return -1;
      });
  };
  const onSubmit = (data) => {
    //수정완료 눌렀을 때,
    const {
      joinerName,
      cellphone,
      detailAddress,
      groupName,
      // participantCellphone,
      // runnerName,
      // gender,
    } = data;
    console.log('==========================');
    console.log(data);
    console.log(choiceOption);
    console.log(ticketOption);
    console.log('==========================');

    let addressInBuilding = address.roadAddress; //건물명 있을때는 추가해주기
    if (address.buildingName) {
      addressInBuilding += `(${address.buildingName})`;
    }
    if (address.roadAddress !== '') {
      joiner.zipcode = address.zonecode;
      joiner.zipAddress = addressInBuilding;
    }
    //joiner 정보 setting
    if (joiner.paymentStatus === 'RSVT') {
      joiner.joinerName = joinerName;
      joiner.exponent = groupName;
      // runner.runnerName = runnerName;
      // runner.cellphone = participantCellphone;
    }
    joiner.cellphone = cellphone;
    joiner.address = detailAddress;

    //runner 기본 정보 setting
    // runner.gender = gender;
    // runner.choiceOption = choiceOption[0];

    // for (let i in runners) {
    //   //각 종목별 runner의 기념품 choiceOption setting
    //   runners[i].cellphone = participantCellphone;
    //   if (joiner.paymentStatus === "RSVT") {
    //     runners[i].runnerName = runnerName;
    //     runners[i].gender = gender;
    //   }
    //   if (
    //     joiner.paymentStatus !== "CMPL" &&
    //     (choiceOption[i] !== null || choiceOption[i] !== undefined)
    //   ) {
    //     //choiceOption state가 존재한다면...
    //     runners[i].choiceOption = choiceOption[i];
    //   }
    // }
    // for (let i = 0; i < ticketInfo.length; i++) {
    //   if (ticketInfo[i].ticketName === ticketOption[0]) {
    //     runner.ticketSeq = i + 1;
    //     runner.ticketName = ticketOption[0];
    //     runners[0].ticketSeq = i + 1;
    //     runners[0].ticketName = ticketOption[0];
    //   }
    // }

    //update 시켜줘야함!!
    console.log('update시켜줄 정보');
    console.log(joiner);
    // console.log(runners);
    console.log(runnerList);
    const runners = runnerList;
    axios({
      method: 'put',
      url: `${root_url}/api/application/update`,
      data: { joiner, runners },
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => {
        console.log(res);
        setNeedUpdateOnComp(false);
        setNeedUpdateOnRsvt(false);
      })
      .catch((e) => {
        if (e.response === undefined) {
          alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
        } else {
          alert(e.response.data.errorMessage);
        }
      });
  };
  useEffect(() => {
    //cmpl인 joiner의 경우, 수정이 불가능하도록 함
    console.log(joiner);
    if (joiner.paymentStatus === 'CMPL') {
      setIsEditPossible(false);
    }
  }, [joiner]);
  useEffect(() => {
    // 만약, 매진된 티켓이 포함되어있다면 결제가 불가능하도록 유도한다.
    console.log(runnerList);
    console.log(ticketInfo);
    const soldout_ticketSeq_list = [];
    for (let ticket in ticketInfo) {
      if (ticketInfo[ticket].total >= ticketInfo[ticket].acceptable) {
        //매진된 티켓 정보를 리스트에 추가
        soldout_ticketSeq_list.push(ticketInfo[ticket].ticketSeq);
      }
    }
    for (let runner in runnerList) {
      if (soldout_ticketSeq_list.includes(runnerList[runner].ticketSeq)) {
        setIsPayPossible(false);
        break;
      }
    }
  }, [ticketInfo, runnerList]);
  useEffect(() => {
    console.log(cookies.orderIdCookie);
  }, [cookies.orderIdCookie]);
  const onClickPay = async () => {
    // 결제 버튼을 눌렀을 때, 결제 방법에 따른 처리와 정보 업데이트 필요
    //결제방법, 상태를 put해줘야함. joiner만 업데이트 하면 됨.
    // const res = await onUpdateRunner();
    if (res === -1) return; //runner update제대로 안되면 리턴해야함
    else {
      let orderId = uuidv4(); // uuid로 orderId 설정
      await setCookie('orderIdCookie', orderId, {
        path: '/',
        maxAge: 600,
      });
      joiner.paymentType = isCard ? 'CARD' : 'BANK';
      joiner.paymentStatus = 'RSVT';
      // joiner.joinTime = new Date();
      if (joiner.amount > 0) {
        //유료 종목 있는 경우, 카드와 계좌이체에 따라 결제 상태 다르다.
        if (isCard) {
          //카드결제 -> toss payments 실행, card&success url로 접근하면 PayComplete.js에서 CMPL로 update해줘야함
          loadTossPayments(clientKey).then((tossPayments) => {
            console.log(
              `${payment_root_url}/success?joinSeq=${encodeURI(joiner.joinSeq)}&joinHash=${orderId}`
            );
            tossPayments
              .requestPayment('카드', {
                amount: joiner.amount,
                orderId: orderId,
                orderName: orderName, //상품명을 어떻게 넣어야할지 잘 생각해보자
                customerName: joiner.joinerName,
                customerMobilePhone: joiner.cellphone,
                successUrl: `${payment_root_url}/success?joinSeq=${encodeURI(
                  joiner.joinSeq
                )}&joinHash=${orderId}`,
                failUrl: `${payment_root_url}/apply/fail`,
              })
              .catch((e) => {
                if (e.code === 'USER_CANCEL') {
                  //중간에 사용자가 나간 경우
                  console.log(
                    `${payment_root_url}/success?joinSeq=${encodeURI(
                      joiner.joinSeq
                    )}&joinHash=${orderId}`
                  );
                  alert('결제 도중 취소되었습니다. 다시 결제를 진행해주세요.');
                }
              });
          });
        } else {
          //계좌이체(유료) -> redirect만 해주면 된다. PayComplete에서도 해줄건 보여주는 거밖에 없다.
          history.push(`/apply/success?joinSeq=${encodeURI(joiner.joinSeq)}&joinHash=${orderId}`);
        }
      } else {
        //결제금액이 0원인 경우,
        //결제완료 페이지로 redirect해준다. bank이며 cmpl인 경우에 PayComplete에서는 딱히 해줄 건 없다.
        history.push(`/apply/success?joinSeq=${encodeURI(joiner.joinSeq)}&joinHash=${orderId}`);
      }
    }
  };
  const onClickCancel = () => {
    const answer = window.confirm(
      '신청을 취소하시겠습니까? 취소한 이후에는 처음부터 예약을 진행해야합니다.'
    );
    if (answer) {
      axios({
        method: 'delete',
        url: `${root_url}/api/application/cancel`,
        data: {
          joinSeq: joiner.joinSeq,
          cellphone: joiner.cellphone,
          joinerName: joiner.joinerName,
        },
        headers: { 'Content-Type': 'application/json' },
      })
        .then((res) => {
          // console.log(res);
          if (res.status === 200) {
            alert(`${joiner.joinerName}님의 신청이 정상적으로 취소되었습니다.`);
            history.push('/apply/individual');
          }
        })
        .catch((e) => {
          if (e.response === undefined) {
            alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
          } else {
            alert(e.response.data.errorMessage);
          }
        });
    }
  };
  const moveToPayComplete = async (joiner) => {
    //결제가 완료된 신청자의 경우, 결제 div가 없지만 신청화면은 볼 수 있도록 해야한다.
    let orderId = uuidv4(); // uuid로 orderId 설정
    await setCookie('orderIdCookie', orderId, {
      path: '/',
      maxAge: 600,
    });
    history.push(`/apply/success?joinSeq=${encodeURI(joiner.joinSeq)}&joinHash=${orderId}`);
  };
  const onClickPrint = () => {
    //backno가 있는지 확인
    if (runner.backNo !== null) {
      // window.open()
      return;
    }
    alert('오프라인 마라톤 종목이 신청되지 않았거나, 등번호가 아직 지정되지 않았습니다.');
  };
  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container className="mb-5">
          <h3 className="mb-5 mt-5">{title}</h3>
          <h4 className="text-custom-color">접수자 정보</h4>
          <table className="table border">
            <tbody>
              <tr>
                <td className="col-3 fw-bold text-danger">접수번호</td>
                <td className="fw-bold h4">{joiner.joinSeq}</td>
              </tr>
              {/* <tr>
                <td colSpan="2" className="text-danger">
                  접수번호는 신청 조회 및 수정 그리고 언텍트M/언텍트T 기록
                  측정에 반드시 필요합니다.
                </td>
              </tr> */}
              {/* 단체인 경우에는 단체명도 수정할 수 있어야함 */}
              {runners.length >= 2 && (
                <tr>
                  <td>단체명</td>
                  <td>
                    {needUpdateOnRsvt ? (
                      <div className="col-xs-9 col-sm-7 col-md-5 col-lg-4">
                        <input
                          type="text"
                          defaultValue={joiner.exponent}
                          {...register('groupName', {
                            required: true,
                            maxLength: 50,
                            pattern: /^[A-Z|a-z|가-힣\s]{2,50}$/g,
                          })}
                        />
                        {errors.groupName && (
                          <span
                            className="position-absolute"
                            style={{ fontSize: '0.8rem', color: 'red' }}
                          >
                            (필수)단체명을 제대로 입력했나 확인해주세요.
                          </span>
                        )}
                      </div>
                    ) : (
                      joiner.exponent
                    )}
                  </td>
                </tr>
              )}
              <tr>
                <td>접수자 성명</td>
                <td>
                  {needUpdateOnRsvt ? (
                    <div className="col-xs-9 col-sm-7 col-md-5 col-lg-4">
                      <input
                        type="text"
                        defaultValue={joiner.joinerName}
                        {...register('joinerName', {
                          required: true,
                          maxLength: 50,
                          pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
                        })}
                      />
                      {errors.joinerName && (
                        <span
                          className="position-absolute"
                          style={{ fontSize: '0.8rem', color: 'red' }}
                        >
                          (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
                        </span>
                      )}
                    </div>
                  ) : (
                    joiner.joinerName
                  )}
                </td>
              </tr>
              <tr>
                <td>휴대전화</td>
                <td>
                  {needUpdateOnComp || needUpdateOnRsvt ? (
                    <div className="col-xs-9 col-sm-7 col-md-5 col-lg-4">
                      <input
                        type="number"
                        defaultValue={joiner.cellphone}
                        {...register('cellphone', {
                          required: true,
                          maxLength: 11,
                          pattern: /^[0-9]{4,11}/g,
                        })}
                      />
                      {errors.cellphone && (
                        <span
                          className="position-absolute"
                          style={{ fontSize: '0.8rem', color: 'red' }}
                        >
                          (필수)전화번호는 4자 이상, 11자 이하의 숫자만 입력해주세요.
                        </span>
                      )}
                    </div>
                  ) : (
                    joiner.cellphone
                  )}
                </td>
              </tr>
              <tr>
                <td>주소</td>
                <td>
                  {needUpdateOnComp || needUpdateOnRsvt ? (
                    <div className="col-xs-9 col-sm-7">
                      <input
                        type="text"
                        className="me-3"
                        value={address.roadAddress ? address.roadAddress : joiner.zipAddress}
                      />
                      <Button className="bg-custom-color" onClick={() => setPopupShow(true)}>
                        주소 검색하기
                      </Button>
                    </div>
                  ) : (
                    joiner.zipAddress
                  )}
                </td>
              </tr>
              <tr>
                <td>상세주소</td>
                <td>
                  {needUpdateOnComp || needUpdateOnRsvt ? (
                    <div>
                      <input
                        type="text"
                        defaultValue={joiner.address}
                        {...register('detailAddress', { required: true })}
                      />
                      {errors.detailAddress && (
                        <span
                          className="ms-3"
                          style={{
                            fontSize: '0.8rem',
                            color: 'red',
                          }}
                        >
                          (필수)상세주소를 입력해주세요
                        </span>
                      )}
                    </div>
                  ) : (
                    joiner.address
                  )}
                </td>
              </tr>
              <tr>
                <td className="fw-bold">예약상태</td>
                <td className="text-custom-color">
                  {joiner.paymentStatus === 'CMPL'
                    ? '입금완료'
                    : joiner.paymentStatus === 'CNCL'
                      ? '참가취소'
                      : '입금대기'}
                </td>
              </tr>
            </tbody>
          </table>
        </Container>
        <Container className="mb-5">
          {/* <table className="table border">
            <tbody>
              <tr>
                <td className="col-3">참가자 성명</td>
                <td>
                  {needUpdateOnRsvt ? (
                    <div className="col-xs-9 col-sm-7 col-md-5 col-lg-4">
                      <input
                        type="text"
                        defaultValue={runner.runnerName}
                        {...register("runnerName", {
                          required: true,
                          maxLength: 50,
                          pattern: /^[A-Z|a-z|가-힣]{2,50}$/g,
                        })}
                      />
                      {errors.runnerName && (
                        <span
                          className="position-absolute"
                          style={{ fontSize: "0.8rem", color: "red" }}
                        >
                          (필수)이름을 공백없이 제대로 입력했나 확인해주세요.
                        </span>
                      )}
                    </div>
                  ) : (
                    runner.runnerName
                  )}
                </td>
              </tr>
              <tr>
                <td>휴대전화</td>
                <td>
                  {needUpdateOnComp || needUpdateOnRsvt ? (
                    <div className="col-xs-9 col-sm-7 col-md-5 col-lg-4">
                      <input
                        type="number"
                        defaultValue={runner.cellphone}
                        {...register("participantCellphone", {
                          required: true,
                          maxLength: 11,
                          pattern: /^[0-9]/g,
                        })}
                      />
                      {errors.participantCellphone && (
                        <span
                          className="ms-3"
                          style={{
                            fontSize: "0.8rem",
                            color: "red",
                          }}
                        >
                          (필수)전화번호는 11자 이하의 숫자만 입력해주세요.
                        </span>
                      )}
                    </div>
                  ) : (
                    runner.cellphone
                  )}
                </td>
              </tr>
              <tr>
                <td>생년월일</td>
                <td>
                  {needUpdateOnRsvt ? (
                    <div>
                      <input
                        type="number"
                        defaultValue={runner.birthday}
                        {...register("birthday", {
                          required: true,
                          maxLength: 8,
                          pattern: /^[0-9]{8,8}/g,
                        })}
                      />
                      {errors.birthday && (
                        <span
                          className="position-absolute"
                          style={{ fontSize: "0.8rem", color: "red" }}
                        >
                          (필수)1999/03/20 → 19990320 8자리로 입력해주세요.
                        </span>
                      )}
                    </div>
                  ) : (
                    runner.birthday
                  )}
                </td>
              </tr>
              <tr>
                <td>성별</td>
                <td>
                  {needUpdateOnRsvt ? (
                    <select
                      defaultValue={runner.gender}
                      {...register("gender", { required: true })}
                      style={{
                        display: "block",
                        width: "14.5rem",
                        height: "2.5rem",
                      }}
                    >
                      <option value="M">남자</option>
                      <option value="F">여자</option>
                    </select>
                  ) : runner.gender === "M" ? (
                    "남자"
                  ) : (
                    "여자"
                  )}
                </td>
              </tr>
              <tr>
                <td>코스 / 기념품</td>
                <td>
                  {runners.map((runner, key) => {
                    //각 종목(runner)마다 하나의 loop
                    // console.log(runner.ticketSeq);
                    // console.log(ticketInfo[runner.ticketSeq - 1]);
                    console.log(choiceOption[0]);
                    return (
                      <div key={key}>
                        {needUpdateOnRsvt &&
                        runner.ticketType !== "trekking" ? (
                          runner.ticketType === "offline" ? (
                            <div className="mb-1">
                              <select
                                defaultValue={runner.ticketName}
                                value={ticketOption[key]}
                                onChange={(e) => {
                                  setTicketOption({
                                    ...ticketOption,
                                    [key]: e.target.value,
                                  });
                                }}
                              >
                                {ticketInfo.map((option) => {
                                  return (
                                    option.ticketType === "offline" && (
                                      <option
                                        value={option.ticketName}
                                        key={option.ticketName}
                                      >
                                        {option.ticketName}
                                      </option>
                                    )
                                  );
                                })}
                              </select>
                              <select
                                defaultValue={runner.choiceOption}
                                value={choiceOption[key]}
                                onChange={(e) => {
                                  // alert(e.target.value);
                                  console.log(
                                    `key: ${key}, choiceOption[key]: ${choiceOption[key]}, e.target.value: ${e.target.value}`
                                  );
                                  // alert(e.target.value);
                                  setChoiceOption({
                                    ...choiceOption,
                                    [key]: e.target.value,
                                  });
                                  console.log(choiceOption);
                                }}
                              >
                                {ticketInfo[runner.ticketSeq - 1].choiceOption
                                  .split(",")
                                  .map((option) => {
                                    return (
                                      <option value={option} key={option}>
                                        {option}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          ) : (
                            //수정해야하는데, choiceOption이 있는 종목(offline, online)인 경우,
                            //select 보여줘야함
                            <div className="mb-1">
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "10rem",
                                }}
                              >
                                {runner.ticketName}
                              </span>
                              <select
                                defaultValue={runner.choiceOption}
                                value={choiceOption[key]}
                                onChange={(e) => {
                                  // alert(e.target.value);
                                  console.log(
                                    `key: ${key}, choiceOption[key]: ${choiceOption[key]}, e.target.value: ${e.target.value}`
                                  );
                                  // alert(e.target.value);
                                  setChoiceOption({
                                    ...choiceOption,
                                    [key]: e.target.value,
                                  });
                                  console.log(choiceOption);
                                }}
                              >
                                {ticketInfo[runner.ticketSeq - 1].choiceOption
                                  .split(",")
                                  .map((option) => {
                                    return (
                                      <option value={option} key={option}>
                                        {option}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                          )
                        ) : (
                          //수정하지 않아도 되거나 트레킹의 경우, 그냥 보여주면 됨 (choiceOption이 있다면 /XL처럼 보여줘야함)
                          <p>
                            {runner.ticketName} {` `}
                            {runner.choiceOption === null ||
                            runner.choiceOption === undefined
                              ? ""
                              : `/ ${runner.choiceOption}`}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </td>
              </tr>
            </tbody>
          </table> */}
          {isFromSearch === true &&
            joiner.paymentStatus !== 'CNCL' &&
            (needUpdateOnComp || needUpdateOnRsvt ? (
              <button className="bg-custom-color button-in-class text-white" onSubmit={onSubmit}>
                수정완료
              </button>
            ) : (
              <div>
                <Row>
                  <Col
                    xs={{ span: 10, offset: 1 }}
                    md={{ span: 3, offset: 2 }}
                    className="mb-3 mb-md-0"
                  >
                    <div
                      className="bg-custom-color text-center cursor-pointer p-1 rounded text-white"
                      onClick={() => {
                        if (isEditPossible) {
                          console.log(`choiceOption : ${runner.choiceOption}`);
                          if (joiner.paymentStatus === 'RSVT') {
                            setNeedUpdateOnRsvt(true);
                          } else if (joiner.paymentStatus === 'CMPL') {
                            setNeedUpdateOnComp(true);
                          }
                        } else {
                          alert('수정이 필요한 경우 관리자에게 문의해주세요.');
                        }
                      }}
                    >
                      접수자 정보 수정하기
                    </div>
                  </Col>
                  <Col xs={{ span: 10, offset: 1 }} md={{ span: 3, offset: 2 }}>
                    {(joiner.amount > 0 && joiner.paymentStatus === 'RSVT') ||
                      joiner.amount === 0 ? (
                      <div
                        onClick={onClickCancel}
                        className="bg-secondary text-center cursor-pointer p-1 rounded text-white"
                      >
                        신청 취소하기
                      </div>
                    ) : (
                      <div className="bg-secondary text-center p-1 rounded text-white">
                        신청 취소하기
                      </div>
                    )}
                    <p style={{ fontSize: '0.8rem' }} className="text-center text-lg-start">
                      (결제가 완료된 경우, 취소는 관리자에게 문의하세요)
                    </p>
                  </Col>
                </Row>
              </div>
            ))}
          <RunnersParticipantForm
            info={{
              ticketInfo,
              ticketArray: ticketInfo,
            }}
            joiner={joiner}
            runnerList={runnerList}
            setRunnerList={setRunnerList}
            isOnPay={true}
            isEditPossible={isEditPossible}
            setFlag={setFlag}
          />
          <Modal show={popupShow} onHide={() => setPopupShow(false)} size="lg" centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <DaumPostCode onComplete={onCompletePostCode} />
            </Modal.Body>
          </Modal>
        </Container>
      </form>
      {joiner.paymentStatus === 'CMPL' && (
        <Container>
          <Row>
            <button
              className="bg-custom-color button-in-class text-white mt-5"
              onClick={() => moveToPayComplete(joiner)}
            >
              신청 확인
            </button>
          </Row>
          {/* <Row>
            <button
              className="bg-secondary button-in-class text-white mt-5"
              // onClick={onClickPrint}
              onClick={handlePrint}
            >
              등번호 출력
            </button>
            <ComponentToPrint
              ref={componentToPrintRef}
              name={runner.runnerName}
              backNo={runner.backNo}
              ticketName={runner.ticketName}
            />
          </Row> */}
        </Container>
      )}
      {/* CMPL이고 backNo!==null일때 backNo를 출력할 수 있도록 하는 것 */}
      {/* {joiner.paymentStatus ==="CMPL" } */}
      {joiner.amount !== 0 &&
        joiner.paymentStatus === 'RSVT' && ( //돈은 내야하지만, 신청완료 상태일때만 결제하기를 보여주면 된다.
          <Container className="mt-3 mb-5">
            <h4 className="text-custom-color">결제 정보</h4>
            <h5>
              결제 금액: <span className="fw-bold">{한국화폐표현(joiner.amount)}</span>원
            </h5>
            <table className="table border">
              <tbody>
                <tr>
                  <td>하프 코스</td>
                  <td>35,000원</td>
                </tr>
                <tr>
                  <td>미니 코스</td>
                  <td>35,000원</td>
                </tr>
                <tr>
                  <td>건강 코스</td>
                  <td>20,000원</td>
                </tr>
              </tbody>
            </table>
            <p className="fw-bold">결제 방법</p>
            {isPayPossible ? (
              <>
                <p>계좌이체와 카드결제가 가능합니다.</p>
                <Row>
                  <Col xs={{ span: 1 }}>
                    <input
                      type="checkbox"
                      checked={!isCard}
                      onChange={(e) => {
                        if (e.target.value) setIsCard(false);
                        else setIsCard(true);
                      }}
                    />
                  </Col>
                  <Col xs={{ span: 3 }}>
                    <div
                      className={`${isCard ? 'bg-custom-grey' : 'bg-custom-color text-white'
                        } rounded-pill cursor-pointer p-1 text-center`}
                      onClick={() => setIsCard(false)}
                    >
                      계좌이체
                    </div>
                  </Col>
                  <Col>
                    <Container>
                      <p className="fw-bold">계좌이체 안내</p>
                      <p>
                        계좌이체시 입금자명 :
                        <span className="text-custom-color">
                          '최초 접수시 접수자성명+휴대전화 뒷자리(4자리)'
                        </span>
                      </p>
                      {/* 결제안된 상태에서만 보여주므로,  */}
                      <p className="border p-3 text-center">{joiner.brief}</p>
                      <p>
                        <span className="bolder">입금계좌 : </span> 하나은행 654-910058-91905
                      </p>
                      <p>
                        <span className="bolder">예금주 : </span> 대전광역시 대덕구체육회
                      </p>
                    </Container>
                  </Col>
                </Row>
                <Row className="mt-3 mb-5">
                  <Col xs={{ span: 1 }}>
                    <input
                      type="checkbox"
                      checked={isCard}
                      onChange={(e) => {
                        if (e.target.value) {
                          setIsCard(true); //임시로 카드 막음
                        } else setIsCard(false);
                      }}
                    />
                  </Col>
                  <Col xs={{ span: 3 }}>
                    <div
                      className={`${isCard ? 'bg-custom-color text-white' : 'bg-custom-grey'
                        } rounded-pill cursor-pointer p-1 text-center`}
                      onClick={() => setIsCard(true)}
                    >
                      카드 결제
                    </div>
                  </Col>
                  <Col>
                    <Container>
                      <p className="fw-bold">카드결제 안내</p>
                      <p>하나카드는 '외환'으로 선택바랍니다.</p>
                    </Container>
                  </Col>
                </Row>
                <Col
                  xs={{ span: 4 }}
                  className="cursor-pointer rounded bg-custom-color text-center text-white p-1 mt-5"
                  onClick={onClickPay}
                >
                  {/* {isCard ? '결제하기' : '입금 신청하기'} */}
                  결제
                </Col>
              </>
            ) : (
              <Row className="text-danger m-2">
                매진된 참가 종목이 있어서 결제가 불가능하오니, 관리자에게 문의하시길 바랍니다.
              </Row>
            )}
          </Container>
        )}
    </Container>
  );
  //트레킹의 경우, 결제가 필요 없다.
};
export default Payment;

class ComponentToPrint extends React.Component {
  render() {
    const { name, backNo, ticketName } = this.props;
    console.log('ticketName: ' + ticketName);
    return (
      <div
        className="backno text-center"
        style={{
          height: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundImage: 'url(/backNumberMold.png)',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <p
          style={{
            fontWeight: '800',
            fontSize: '15rem',
            letterSpacing: '1rem',
            paddingTop: '8rem',
            marginBottom: 0,
            paddingBottom: 0,
          }}
        >
          {backNo}
        </p>
        <p
          // className="text-start"
          style={{
            display: 'inline-block',
            fontSize: '8rem',
            transform: 'translate(-5rem,-5rem)',
          }}
        >
          {name}
        </p>
        <p
          style={{
            display: 'inline-block',
            transform: 'translateY(-8rem)',
            fontSize: '2rem',
            marginLeft: '5rem',
          }}
        >
          {ticketName}
        </p>
      </div>
    );
  }
}
